<template>
  <div style="padding: 20px">
    <div style="font-size: 16px; font-weight: 600; margin-bottom: 12px">Google OAuth Demo</div>

    <div style="margin-bottom: 12px; color: #666; font-size: 13px">
      <div>
        <span style="font-weight: 600">VUE_APP_GOOGLE_CLIENT_ID:</span>
        <span style="margin-left: 6px">{{ clientId || '(empty)' }}</span>
      </div>
      <div style="margin-top: 6px">
        <span style="font-weight: 600">redirect_uri:</span>
        <span style="margin-left: 6px">{{ redirectUri || '(empty)' }}</span>
      </div>
      <div style="margin-top: 6px">
        <span style="font-weight: 600">window.location.origin:</span>
        <span style="margin-left: 6px">{{ origin || '(empty)' }}</span>
      </div>
    </div>

    <div style="margin-bottom: 12px">
      <el-button type="primary" @click="handleAuthorize">Authorize (Redirect)</el-button>
    </div>

    <div style="margin-bottom: 8px">
      <div style="font-weight: 600; margin-bottom: 6px">Result</div>
      <pre style="white-space: pre-wrap; background: #f7f7f7; padding: 12px; border-radius: 6px">{{ result }}</pre>
    </div>

    <div style="color: #999; font-size: 12px">
      clientId is read from <code>VUE_APP_GOOGLE_CLIENT_ID</code>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleOauthDemo',
  data() {
    return {
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID || '',
      redirectUri:
        typeof window !== 'undefined' && window.location
          ? `${window.location.origin}/google-oauth-callback`
          : '',
      // redirectUri: 'https://api.mail-talk.net/auth2/back',
      origin: typeof window !== 'undefined' && window.location ? window.location.origin : '',
      result: '',
      popup: null
    }
  },
  mounted() {
    try {
      window.addEventListener('message', this.handleMessage)
    } catch (e) {
    }
  },
  beforeUnmount() {
    try {
      window.removeEventListener('message', this.handleMessage)
    } catch (e) {
    }
  },
  methods: {
    handleMessage(event) {
      try {
        if (!event || event.origin !== window.location.origin) return
        const data = event.data || {}
        if (data && data.type === 'google_oauth_done') {
          const token = localStorage.getItem('token')
          this.result = JSON.stringify(
            {
              message: 'OAuth done (popup).',
              token: token || '(empty)'
            },
            null,
            2
          )
          try {
            if (this.popup && !this.popup.closed) this.popup.close()
          } catch (e) {
          }
        }
      } catch (e) {
      }
    },
    async handleAuthorize() {
      try {
        this.result = ''

        if (!this.clientId) {
          this.result = 'VUE_APP_GOOGLE_CLIENT_ID is empty. Please set it and restart dev server.'
          return
        }

        if (!this.redirectUri) {
          this.result = 'redirectUri is empty.'
          return
        }

        const state = `${Date.now()}_${Math.random().toString(16).slice(2)}`
        const params = new URLSearchParams({
          client_id: this.clientId,
          redirect_uri: this.redirectUri,
          response_type: 'code',
          scope: 'openid email profile',
          access_type: 'offline',
          prompt: 'consent',
          state
        })

        const url = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`
        this.result = url
        const width = 520
        const height = 680
        let left = 0
        let top = 0
        try {
          const winX = window.screenX !== undefined ? window.screenX : window.screenLeft
          const winY = window.screenY !== undefined ? window.screenY : window.screenTop
          const winW = window.outerWidth || window.innerWidth || document.documentElement.clientWidth || screen.width
          const winH = window.outerHeight || window.innerHeight || document.documentElement.clientHeight || screen.height
          left = winX + (winW - width) / 2
          top = winY + (winH - height) / 2
        } catch (e) {
        }

        let fixedLeft = Math.floor(left)
        let fixedTop = Math.floor(top)
        try {
          const availLeft = screen.availLeft !== undefined ? screen.availLeft : 0
          const availTop = screen.availTop !== undefined ? screen.availTop : 0
          const availWidth = screen.availWidth || screen.width
          const availHeight = screen.availHeight || screen.height

          const minLeft = availLeft
          const maxLeft = availLeft + availWidth - width
          const minTop = availTop
          const maxTop = availTop + availHeight - height

          fixedLeft = Math.min(Math.max(fixedLeft, minLeft), maxLeft)
          fixedTop = Math.min(Math.max(fixedTop, minTop), maxTop)
        } catch (e) {
        }
        const features = `width=${width},height=${height},left=${fixedLeft},top=${fixedTop},screenX=${fixedLeft},screenY=${fixedTop},menubar=no,toolbar=no,location=yes,status=no,scrollbars=yes,resizable=yes`
        const popup = window.open('about:blank', 'google_oauth', features)
        if (!popup) {
          this.result = 'Popup blocked. Please allow popups and try again.'
          return
        }
        try {
          popup.resizeTo && popup.resizeTo(width, height)
          popup.moveTo && popup.moveTo(fixedLeft, fixedTop)
        } catch (e) {
        }

        try {
          popup.location.href = url
        } catch (e) {
          try {
            popup.location = url
          } catch (e2) {
          }
        }
        this.popup = popup
        popup.focus && popup.focus()
      } catch (e) {
        this.result = String(e && (e.message || e))
      }
    }
  }
}
</script>
